/**
 * GEN-3604 — conta que só entra pela Microsoft.
 *
 * O backend responde 403 `AUTH_SSO_ONLY` no login por senha e em esqueci/redefinir senha quando a
 * conta é exclusiva de SSO. Sem tradução, o código caía no `default` de cada tela ("Email ou Senha
 * são inválidos", "Usuário não encontrado…") — a pessoa corrigia uma senha que não existe em vez de
 * usar o botão certo. A frase é a mesma nas três telas para o caminho ficar óbvio.
 */
export const AUTH_SSO_ONLY = "AUTH_SSO_ONLY";

export const AUTH_SSO_ONLY_MESSAGE = "Sua conta entra pela Microsoft. Use o botão 'Entrar com Microsoft'.";

export const isSsoOnlyCode = (code: unknown): boolean => code === AUTH_SSO_ONLY;
